import { Box, Button, Flex, Title } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";


const MetricWithActionButton = ({label,buttonLabel,onClick}) => {

  return (
    <Box>
      <Flex justify="center" align="center" direction="column" wrap="nowrap">
        <Title order={1} fw={400} c={"#E72166"}>
          {label}
        </Title>
        <Button 
          justify="center" size="xs" radius={'xl'}
          leftSection={<IconInfoCircle size={18} />}
          onClick={onClick}
        >
          {buttonLabel}
        </Button>
      </Flex>
    </Box>
  );
}

export default MetricWithActionButton;